var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQualifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1625_705)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.8C0 0.805888 0.805889 0 1.8 0H16.2C17.1941 0 18 0.805835 18 1.7999L18.0008 6.60142L17.0401 5.8797C16.1376 5.20159 15.0166 4.8 13.8 4.8C10.8177 4.8 8.4 7.21766 8.4 10.2C8.4 11.4166 8.80159 12.5376 9.4797 13.4401L9.6 13.6003V18H1.8C0.805888 18 0 17.1941 0 16.2V1.8ZM9.6 6H3.6V4.8H9.6V6ZM3.6 9.6H7.2V8.4H3.6V9.6Z",
    fill: "black",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8 6C11.4804 6 9.59998 7.8804 9.59998 10.2C9.59998 11.3444 10.0577 12.3818 10.8 13.1394V17.4C10.8 17.6273 10.9284 17.835 11.1316 17.9366C11.3349 18.0383 11.5782 18.0163 11.76 17.88L13.8 16.35L15.84 17.88C16.0218 18.0163 16.265 18.0383 16.4683 17.9366C16.6716 17.835 16.8 17.6273 16.8 17.4V13.1394C17.5423 12.3818 18 11.3444 18 10.2C18 7.8804 16.1196 6 13.8 6ZM12 16.2V13.9958C12.5455 14.255 13.1558 14.4 13.8 14.4C14.4441 14.4 15.0545 14.255 15.6 13.9958V16.2L14.16 15.12C13.9466 14.96 13.6533 14.96 13.44 15.12L12 16.2Z",
    fill: "black",
    fillOpacity: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1625_705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualifications);
export default __webpack_public_path__ + "static/media/Qualifications.a9982c1c.svg";
export { ForwardRef as ReactComponent };